<template>
  <div class="topics-page page-container pt-3 pb-4">
    <b-tabs v-if="!slug || categories.length > 0" @activate-tab="pushRoute" class="topics-tabs" lazy>
      <b-tab :title="$_t('KW:topics')" :active="activeTab == 'topics'">
        <div class="my-5" v-if="!this.topicCategoryUrl">
          <TopicCategoryList :showTitle="false"></TopicCategoryList>
        </div>
        <div v-else>
          <topic-list :topic-categories="topicCategories" :topic-category="topicCategory" :topic-category-url="topicCategoryUrl"></topic-list>
        </div>
      </b-tab>
      <b-tab :key="cat.id" v-for="cat in categories" :title="cat.name + ' Shiurim'" :active="activeTab === cat.url_key">
        <CategoryListSingle class="my-5" :slug="cat.url_key" :showTitle="false" :key="cat.id" :singleCategoryUrl="cat.url_key" :perCategory="100" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import MagideiShiurComponent from './magideiShiur/MagideiShiurList.vue';
import ShiurimTableComponent from './torahShiurim/ShiurimTable.vue';
import TopicListComponent from './torahShiurim/TopicList.vue';
import TopicCategoryComponent from './topics/topicCategoryList';
import CategoryListSingle from './torahShiurim/CategoryListSingle';
import { mapGetters } from 'vuex';
export default {
  metaInfo() {
    return { title: this.$_t('KW:topics') };
    // return { title: this.$_t('KW:torahShiurim') };
  },

  props: ['slug'],

  components: {
    MagideiShiur: MagideiShiurComponent,
    ShiurimTable: ShiurimTableComponent,
    TopicList: TopicListComponent,
    TopicCategoryList: TopicCategoryComponent,
    CategoryListSingle: CategoryListSingle,
  },

  mounted() {
    this.$store.dispatch('api/loadCategories');

    this.$store.dispatch('api/loadTopicCategories').then(cats => {
      this.topicCategories = cats;
      if (this.topicCategoryUrl) {
        this.topicCategory = cats.find(cat => cat.url_key === this.topicCategoryUrl);
      }
    });
  },

  computed: {
    activeTab: function () {
      return this.slug || 'topics';
    },
    ...mapGetters({
      categories: 'api/categories',
    }),
  },
  data() {
    return {
      topicCategory: null,
      topicCategoryUrl: this.$route.query.category,
      topicCategories: [],
    };
  },
  methods: {
    pushRoute(newTabIndex) {
      if (newTabIndex === 0) this.$router.push('/topics');
      else this.$router.push('/categories/' + this.categories[newTabIndex - 1].url_key);
    },
  },
};
</script>

<style lang="scss">
.topics-page {
  .nav-tabs .nav-item {
    &:hover {
      background: $secondary;
    }
  }
  .nav-tabs {
    @media (max-width: 768px) {
      border-bottom: none;
    }
    .nav-item {
      text-transform: uppercase;
      background-color: $bg-gray;
      width: 20%;
      text-align: center;
      height: 60px;
      display: flex;
      @media (max-width: 768px) {
        min-width: 100px;
        width: 100%;
        height: 50px;
        border-radius: 0;
        a.nav-link {
          padding: 0 10px;
          border-radius: 0;
        }
      }
      a.nav-link {
        align-self: center;
        height: 100%;
        width: 100%;
        color: $dark-blue;
        font-size: 1rem;
        // line-height: 40px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      a.nav-link.active {
        color: $white;
        background: $dark-blue;
        border: 1px solid $dark-blue;
      }
    }
  }
}
.magidei-tabs {
}
</style>
